const actionTypes = {
  GET_ACHIEVEMENTS_REQUEST: 'achievement/GET_ACHIEVEMENTS_REQUEST',
  GET_ACHIEVEMENTS_SUCCESS: 'achievement/GET_ACHIEVEMENTS_SUCCESS',
  GET_ACHIEVEMENTS_ERROR: 'achievement/GET_ACHIEVEMENTS_ERROR',
} as const;

export default actionTypes;
